import React, { useState } from "react";
import PropTypes from "prop-types";

// components
import Control from "./Control";
import Content from "./Content";

// styles
import { AccordionStyled } from "./styles";

// component
export const Accordion = ({
    children,
    controlTitle,
    contentMaxHeight = 200,
    iconSize = 12,
    onOpen = () => {},
    onClose = () => {}
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleIsOpen = () => {
        const newIsOpen = !isOpen;
        newIsOpen ? onOpen() : onClose();
        setIsOpen(newIsOpen);
    };

    return (
        <AccordionStyled>
            <Control
                toggleIsOpen={toggleIsOpen}
                title={controlTitle}
                iconSize={iconSize}
                isOpen={isOpen}
            />
            <Content isOpen={isOpen} contentMaxHeight={contentMaxHeight}>
                {children}
            </Content>
        </AccordionStyled>
    );
};

export default Accordion;

// prop-types
Accordion.propTypes = {
    children: PropTypes.any,
    controlTitle: PropTypes.string.isRequired,
    contentMaxHeight: PropTypes.number,
    iconSize: PropTypes.number,
    onOpen: PropTypes.func,
    onClose: PropTypes.func
};
